import { render } from "./ModuleStyleguideComponentsweb.vue?vue&type=template&id=5436c6a5"
import script from "./ModuleStyleguideComponentsweb.vue?vue&type=script&lang=js"
export * from "./ModuleStyleguideComponentsweb.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__